import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../shared/authentication/auth-guard';
import { Perfis } from '../../models/perfis';

import { GerenciarPrestacaoContasComponent } from './gerenciar-prestacao-contas/gerenciar-prestacao-contas.component';
import { CadastrarLancamentoFormComponent } from './cadastrar-lancamento-form/cadastrar-lancamento-form.component';
import { EnviarPrestacaoAnaliseComponent } from './enviar-prestacao-analise/enviar-prestacao-analise.component';
import { VisualizarPrestacaoContasComponent } from './visualizar-prestacao-contas/visualizar-prestacao-contas.component';
import { CompararDespesasComponent } from './comparar-despesas/comparar-despesas.component';
import { VisualizarGastosTipoFornecedorComponent } from './visualizar-gastos-tipo-fornecedor/visualizar-gastos-tipo-fornecedor.component';
import { ManterContaComponent } from './manter-conta/manter-conta.component';
import { ManterTipoDespesaComponent } from './manter-tipo-despesa/manter-tipo-despesa.component';
// tslint:disable-next-line: import-spacing
import { GerenciarValorDespesaFornecedorComponent }
from './gerenciar-valor-despesa-fornecedor/gerenciar-valor-despesa-fornecedor.component';

// tslint:disable-next-line: import-spacing
import { CadastarValorDespesaFornecedorFormComponent }
from './cadastar-valor-despesa-fornecedor-form/cadastar-valor-despesa-fornecedor-form.component';
import { AdminLayoutComponent } from '../_admin-layout/admin-layout.component';


const FinanceiroRoutes: Routes = [
  { path: '', component: AdminLayoutComponent,
      children: [
        {
          path: 'gerenciar-prestacao-conta',
          component: GerenciarPrestacaoContasComponent,
          canActivate: [AuthGuard],
          data: {
            roles: [
              Perfis.AdministradorSistema, Perfis.GestorDex, Perfis.AdministrativoDex,
              Perfis.GestorUnidadeOperacional, Perfis.AdministrativoUnidadeOperacional
            ]
          }
        },
        // {
        //     path: 'convocar-aluno',
        //     component: ConvocarAlunoComponent,
        //     canActivate: [ AuthGuard ],
        //     data: { roles: [
        //         Perfis.AdministradorSistema, Perfis.GestorDex, Perfis.AdministrativoDex,
        //         Perfis.GestorUnidadeOperacional, Perfis.AdministrativoUnidadeOperacional
        //     ]}
        // },
        { path: 'cadastrar-lancamento-form', component: CadastrarLancamentoFormComponent, canActivate: [ AuthGuard ] },
        { path: 'editar-lancamento-form/:id', component: CadastrarLancamentoFormComponent, canActivate: [ AuthGuard ] },
        { path: 'visualizar-lancamento-form/:id', component: CadastrarLancamentoFormComponent, canActivate: [ AuthGuard ] },
        { path: 'enviar-prestacao-analise/:id', component: EnviarPrestacaoAnaliseComponent, canActivate: [ AuthGuard ] },
        { path: 'visualizar-prestacao-conta/:id', component: VisualizarPrestacaoContasComponent, canActivate: [ AuthGuard ] },
        { path: 'comparar-despesas/:id', component: CompararDespesasComponent, canActivate: [ AuthGuard ] },
        { path: 'visualizar-gastos-fornecedor/:id', component: VisualizarGastosTipoFornecedorComponent, canActivate: [ AuthGuard ] },
        { path: 'manter-conta', component: ManterContaComponent, canActivate: [ AuthGuard ] },
        { path: 'manter-tipo-despesa', component: ManterTipoDespesaComponent, canActivate: [ AuthGuard ] },
        { path: 'gerenciar-valor-despesa-fornecedor', component: GerenciarValorDespesaFornecedorComponent, canActivate: [ AuthGuard ] },
        { path: 'cadastar-despesa-fornecedor', component: CadastarValorDespesaFornecedorFormComponent, canActivate: [ AuthGuard ] },
        { path: 'cadastar-despesa-fornecedor/:id', component: CadastarValorDespesaFornecedorFormComponent, canActivate: [ AuthGuard ] },
        { path: 'gerenciar-prestacao-contas', component: GerenciarPrestacaoContasComponent, canActivate: [ AuthGuard ] },
      ]
  }
];

export const FinanceiroRouting = RouterModule.forChild(FinanceiroRoutes);



// WEBPACK FOOTER //
// ./src/app/components/financeiro/financeiro.routing.ts